import { render, staticRenderFns } from "./hubWisePerformanceReport_KSA.vue?vue&type=template&id=3c3d2058&"
import script from "./hubWisePerformanceReport_KSA.vue?vue&type=script&lang=js&"
export * from "./hubWisePerformanceReport_KSA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports